import React from 'react';

// Import all partner logos
import logoBnr from '../../resource/image/partners/logo-partners-bnr.png';
import logoConns from '../../resource/image/partners/logo-partners-conns.png';
import logoCtns from '../../resource/image/partners/logo-partners-ctns.png';
import logoEllus from '../../resource/image/partners/logo-partners-ellus.png';
import logoEverybot from '../../resource/image/partners/logo-partners-everybot.png';
import logoFst from '../../resource/image/partners/logo-partners-fst.png';
import logoMotor114 from '../../resource/image/partners/logo-partners-motor114.png';
import logoNaas from '../../resource/image/partners/logo-partners-naas.png';
import logoPomax from '../../resource/image/partners/logo-partners-pomax.png';
import logoSkintellix from '../../resource/image/partners/logo-partners-skintellix.png';
import logoSlamko from '../../resource/image/partners/logo-partners-slamko.png';
import logoTelelian from '../../resource/image/partners/logo-partners-telelian.png';
import logoTvotec from '../../resource/image/partners/logo-partners-tvotec.png';
import logoWego from '../../resource/image/partners/logo-partners-wego.png';
import logoZdrobotics from '../../resource/image/partners/logo-partners-zdrobotics.png';

const partners = [
    { name: 'Skintellix', src: logoSkintellix, isVertical: true },
    { name: 'Everybot', src: logoEverybot },
    { name: 'Naas', src: logoNaas, isVertical: true },
    { name: 'CONNS', src: logoConns },
    { name: 'CTNS', src: logoCtns },
    { name: 'FST', src: logoFst },
    { name: 'Motor114', src: logoMotor114, isVertical: true },
    { name: 'ELLUS', src: logoEllus },
    { name: 'BNR', src: logoBnr },
    { name: 'Pomax', src: logoPomax },
    { name: 'Slamko', src: logoSlamko },
    { name: 'Telelian', src: logoTelelian },
    { name: 'Tvotec', src: logoTvotec },
    { name: 'Wego', src: logoWego },
    { name: 'ZDRobotics', src: logoZdrobotics },
];

const SectionPartners = () => {
    return (
        <div className="container mx-auto h-full pt-16 md:pt-24 pb-12 md:pb-24">
            <div className="mb-10 border-b border-black pb-6 text-center">
                <h2 className="text-[clamp(32px,5vw,64px)] font-bold text-black leading-tight tracking-tight">PARTNERS</h2>
            </div>
            <div className="grid grid-cols-3 gap-x-4 gap-y-6 md:grid-cols-5 md:gap-x-6 md:gap-y-8 lg:gap-x-10 lg:gap-y-12 items-center">
                {partners.map((partner, index) => (
                    <div
                        key={index}
                        className="h-[80px] flex items-center justify-center"
                    >
                        <img
                            src={partner.src}
                            alt={`${partner.name} logo`}
                            className={`${partner.isVertical
                                ? 'h-[45px] md:h-[65px]'
                                : 'h-[30px] md:h-[44px]'
                                } w-auto max-w-full object-contain`}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SectionPartners;
